import React from "react";
import logger from "logger";
import { showDialog } from "DialogProvider";
import TaskDialog from "../TaskDialogCommon/TaskDialog";

function ErrorDialog(props) {
  return (
    <TaskDialog heading="Error :(">
      <div>{props.message}</div>
    </TaskDialog>
  );
}

export default {
  showError: (message) => {
    logger.log("Toastmaker not loaded yet");
    showDialog(<ErrorDialog message={message} open={true} />);
  },
};
